var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3273fa",
    d: "M.25 13.998h13.5v1.5H.25zm3.182-1.5H.25V9.316L8.826.74a.75.75 0 011.06 0l2.124 2.12a.75.75 0 010 1.06zm-.621-1.5l7.606-7.606-1.06-1.06L1.75 9.937v1.06z"
  })));
}
export default __webpack_public_path__ + "static/svg/edit-icon.svg";
export { SvgEditIcon as ReactComponent };